(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-media-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wrappers = document.querySelectorAll('.floating-media');
    const now = Date.now();

    const getStorageData = (wrapper) => {
      const sectionId = wrapper.dataset.sectionId;
      const behavior = wrapper.dataset.closeBehavior || 'none';
      const snoozeDays = Number(wrapper.dataset.snoozeDays || '7');
      const key = `floating-media-dismissed-${sectionId}`;
      return { behavior, snoozeDays, key };
    };

    const shouldHide = (wrapper) => {
      const { behavior, key } = getStorageData(wrapper);

      if (behavior === 'session') {
        return sessionStorage.getItem(key) === '1';
      }

      if (behavior === 'permanent') {
        return localStorage.getItem(key) === '1';
      }

      if (behavior === 'snooze') {
        const snoozeUntil = Number(localStorage.getItem(key) || '0');
        return snoozeUntil > now;
      }

      return false;
    };

    const persistDismiss = (wrapper) => {
      const { behavior, key, snoozeDays } = getStorageData(wrapper);

      if (behavior === 'session') {
        sessionStorage.setItem(key, '1');
        return;
      }

      if (behavior === 'permanent') {
        localStorage.setItem(key, '1');
        return;
      }

      if (behavior === 'snooze') {
        const snoozeMs = Math.max(snoozeDays, 1) * 24 * 60 * 60 * 1000;
        localStorage.setItem(key, String(Date.now() + snoozeMs));
      }
    };

    wrappers.forEach((wrapper) => {
      if (shouldHide(wrapper)) {
        wrapper.style.display = 'none';
        return;
      }

      const frame = wrapper.querySelector('.floating-media__frame');
      const closeButton = wrapper.querySelector('[data-floating-close]');
      const muteButton = wrapper.querySelector('[data-floating-mute]');
      const fullscreenButton = wrapper.querySelector('[data-floating-fullscreen]');
      const video = wrapper.querySelector('[data-floating-video]');
      const muteIcon = wrapper.querySelector('[data-icon-mute]');
      const unmuteIcon = wrapper.querySelector('[data-icon-unmute]');

      if (closeButton) {
        closeButton.addEventListener('click', () => {
          persistDismiss(wrapper);
          wrapper.style.display = 'none';
        });
      }

      if (video && muteButton) {
        const syncMuteState = () => {
          muteButton.classList.toggle('is-muted', video.muted);
          muteButton.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
          if (muteIcon) muteIcon.setAttribute('aria-hidden', video.muted ? 'false' : 'true');
          if (unmuteIcon) unmuteIcon.setAttribute('aria-hidden', video.muted ? 'true' : 'false');
        };

        syncMuteState();

        muteButton.addEventListener('click', () => {
          video.muted = !video.muted;
          syncMuteState();
        });
      }

      if (frame && fullscreenButton) {
        fullscreenButton.addEventListener('click', async () => {
          if (!document.fullscreenElement) {
            try {
              await frame.requestFullscreen();
            } catch (error) {}
            return;
          }
          try {
            await document.exitFullscreen();
          } catch (error) {}
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-video-carousel-pdp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('ugc-pdp-videos-init')) return;

    const initSection = (root) => {
      if (!root || root.dataset.ugcInit === '1') return;
      root.dataset.ugcInit = '1';

      const payloadEl = root.querySelector('[data-ugc-payload]');
      let payload = [];
      try { payload = JSON.parse(payloadEl.textContent); } catch (e) { payload = []; }
      if (!payload.length) return;

      const playMode = root.dataset.playMode || 'autoplay';
      const track = root.querySelector('[data-carousel-track]');
      const cards = Array.from(root.querySelectorAll('[data-card]'));
      const modal = root.querySelector('[data-modal]');
      const modalVideo = root.querySelector('[data-modal-video]');
      const indexIndicator = root.querySelector('[data-index-indicator]');
      const pauseBadge = root.querySelector('[data-pause-badge]');
      const progressTrack = root.querySelector('[data-progress-track]');
      const progressFill = root.querySelector('[data-progress-fill]');
      const progressThumb = root.querySelector('[data-progress-thumb]');
      const muteBtn = root.querySelector('[data-modal-mute]');
      const prevBtn = root.querySelector('[data-modal-prev]');
      const nextBtn = root.querySelector('[data-modal-next]');
      const closeBtn = root.querySelector('[data-modal-close]');
      const arrowPrev = root.querySelector('[data-carousel-prev]');
      const arrowNext = root.querySelector('[data-carousel-next]');

      let currentIndex = 0;
      let modalMuted = false;
      let rafId = null;

      /* ── Cards: playback modes ───────────────── */
      const cardVideos = cards.map((c) => c.querySelector('[data-card-video]'));

      if (playMode === 'autoplay') {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target.querySelector('[data-card-video]');
            if (!video) return;
            if (entry.isIntersecting) {
              video.play().catch(() => {});
              entry.target.classList.remove('is-paused');
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.4 });
        cards.forEach((c) => io.observe(c));
      } else if (playMode === 'hover') {
        cards.forEach((card, i) => {
          const video = cardVideos[i];
          if (!video) return;
          card.classList.add('is-paused');
          card.addEventListener('mouseenter', () => {
            video.play().catch(() => {});
            card.classList.remove('is-paused');
          });
          card.addEventListener('mouseleave', () => {
            video.pause();
            card.classList.add('is-paused');
          });
        });
      } else {
        cards.forEach((c) => c.classList.add('is-paused'));
      }

      /* ── Card sound toggles ──────────────────── */
      root.querySelectorAll('[data-card-sound]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const card = btn.closest('[data-card]');
          const video = card && card.querySelector('[data-card-video]');
          if (!video) return;
          video.muted = !video.muted;
          btn.querySelector('.ugc-icon-muted').style.display = video.muted ? '' : 'none';
          btn.querySelector('.ugc-icon-sound').style.display = video.muted ? 'none' : '';
          if (!video.muted) video.play().catch(() => {});
        });
      });

      /* ── Carousel arrows ─────────────────────── */
      const updateArrows = () => {
        if (!arrowPrev || !arrowNext) return;
        const maxScroll = track.scrollWidth - track.clientWidth - 2;
        const overflowing = track.scrollWidth > track.clientWidth + 2;
        arrowPrev.hidden = !overflowing;
        arrowNext.hidden = !overflowing;
        arrowPrev.disabled = track.scrollLeft <= 2;
        arrowNext.disabled = track.scrollLeft >= maxScroll;
      };
      if (arrowPrev && arrowNext) {
        const step = () => {
          const card = cards[0];
          return card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
        };
        arrowPrev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
        arrowNext.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
        track.addEventListener('scroll', updateArrows, { passive: true });
        window.addEventListener('resize', updateArrows);
        updateArrows();
      }

      /* ── Modal ───────────────────────────────── */
      const setMuteUI = () => {
        muteBtn.querySelector('.ugc-icon-muted').style.display = modalMuted ? '' : 'none';
        muteBtn.querySelector('.ugc-icon-sound').style.display = modalMuted ? 'none' : '';
      };

      const loadModalVideo = (index) => {
        currentIndex = (index + payload.length) % payload.length;
        const item = payload[currentIndex];
        modalVideo.innerHTML = '';
        item.sources.forEach((srcObj) => {
          const src = document.createElement('source');
          src.src = srcObj.url;
          src.type = srcObj.mime;
          modalVideo.appendChild(src);
        });
        if (item.poster) modalVideo.poster = item.poster;
        modalVideo.load();
        modalVideo.muted = modalMuted;
        modalVideo.play().catch(() => {});
        pauseBadge.hidden = true;
        if (indexIndicator) indexIndicator.textContent = (currentIndex + 1) + '/' + payload.length;
        if (prevBtn && nextBtn && payload.length < 2) {
          prevBtn.hidden = true;
          nextBtn.hidden = true;
        }
      };

      const openModal = (index) => {
        cardVideos.forEach((v) => v && v.pause());
        loadModalVideo(index);
        modal.showModal();
        document.documentElement.style.overflow = 'hidden';
        startProgressLoop();
      };

      const closeModal = () => {
        modalVideo.pause();
        modalVideo.innerHTML = '';
        modalVideo.removeAttribute('poster');
        modalVideo.load();
        stopProgressLoop();
        if (modal.open) modal.close();
        document.documentElement.style.overflow = '';
        if (playMode === 'autoplay') {
          cards.forEach((card, i) => {
            const rect = card.getBoundingClientRect();
            const visible = rect.top < window.innerHeight && rect.bottom > 0;
            if (visible && cardVideos[i]) cardVideos[i].play().catch(() => {});
          });
        }
      };

      root.querySelectorAll('[data-open-modal]').forEach((btn) => {
        btn.addEventListener('click', () => openModal(parseInt(btn.dataset.index, 10) || 0));
      });
      closeBtn.addEventListener('click', closeModal);
      modal.addEventListener('cancel', (e) => { e.preventDefault(); closeModal(); });
      modal.addEventListener('click', (e) => {
        if (e.target === modal) closeModal();
      });

      if (prevBtn) prevBtn.addEventListener('click', () => loadModalVideo(currentIndex - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => loadModalVideo(currentIndex + 1));

      modal.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft' && prevBtn) loadModalVideo(currentIndex - 1);
        if (e.key === 'ArrowRight' && nextBtn) loadModalVideo(currentIndex + 1);
      });

      /* Tap video to play/pause */
      modalVideo.addEventListener('click', () => {
        if (modalVideo.paused) {
          modalVideo.play().catch(() => {});
          pauseBadge.hidden = true;
        } else {
          modalVideo.pause();
          pauseBadge.hidden = false;
        }
      });

      muteBtn.addEventListener('click', () => {
        modalMuted = !modalMuted;
        modalVideo.muted = modalMuted;
        setMuteUI();
      });
      setMuteUI();

      /* ── Progress bar ────────────────────────── */
      const renderProgress = () => {
        const d = modalVideo.duration;
        const pct = d ? (modalVideo.currentTime / d) * 100 : 0;
        progressFill.style.width = pct + '%';
        progressThumb.style.left = pct + '%';
        progressTrack.setAttribute('aria-valuenow', Math.round(pct));
      };
      const progressLoop = () => {
        renderProgress();
        rafId = requestAnimationFrame(progressLoop);
      };
      const startProgressLoop = () => {
        stopProgressLoop();
        rafId = requestAnimationFrame(progressLoop);
      };
      const stopProgressLoop = () => {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = null;
      };

      const seekFromEvent = (e) => {
        const rect = progressTrack.getBoundingClientRect();
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        let ratio = (clientX - rect.left) / rect.width;
        ratio = Math.max(0, Math.min(1, ratio));
        if (modalVideo.duration) modalVideo.currentTime = ratio * modalVideo.duration;
        renderProgress();
      };

      let scrubbing = false;
      const startScrub = (e) => {
        scrubbing = true;
        progressTrack.classList.add('is-scrubbing');
        seekFromEvent(e);
        e.preventDefault();
      };
      const moveScrub = (e) => { if (scrubbing) seekFromEvent(e); };
      const endScrub = () => {
        scrubbing = false;
        progressTrack.classList.remove('is-scrubbing');
      };

      progressTrack.addEventListener('mousedown', startScrub);
      progressTrack.addEventListener('touchstart', startScrub, { passive: false });
      window.addEventListener('mousemove', moveScrub);
      window.addEventListener('touchmove', moveScrub, { passive: false });
      window.addEventListener('mouseup', endScrub);
      window.addEventListener('touchend', endScrub);

      progressTrack.addEventListener('keydown', (e) => {
        if (!modalVideo.duration) return;
        if (e.key === 'ArrowLeft') modalVideo.currentTime = Math.max(0, modalVideo.currentTime - 5);
        if (e.key === 'ArrowRight') modalVideo.currentTime = Math.min(modalVideo.duration, modalVideo.currentTime + 5);
      });
    };

    const boot = () => {
      document.querySelectorAll('[data-ugc-root]').forEach(initSection);
    };
    boot();
    document.addEventListener('shopify:section:load', (e) => {
      const root = e.target.querySelector('[data-ugc-root]');
      if (root) { root.dataset.ugcInit = ''; initSection(root); }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
